import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=53c49eac&scoped=true&"
import script from "./ItemEdit.vue?vue&type=script&lang=js&"
export * from "./ItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=53c49eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c49eac",
  null
  
)

export default component.exports